var convert = require('./convert'),
    func = convert('startsWith', require('../startsWith'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp/startsWith.js
// module id = 1316
// module chunks = 0